import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React, { useMemo } from "react";

import { useCalendarContext } from "../../../context/calendar_context";
import css from "../../days/days.module.scss";
import { useCalendarHeader } from "../use_calendar_header";
import { DayItem } from "./day_item";

type DaysProps = {
  startDate: string;
  daysCount: number;
};

export const Days = ({ startDate, daysCount }: DaysProps): JSX.Element | null => {
  const { daysHeight } = useCalendarHeader();
  const { dayWidth } = useCalendarContext();
  const { formatISODate, utc } = useDateFormatter();

  const dayItems = useMemo(
    () =>
      [...Array(Math.floor(daysCount))].map((_, dayNumber) => {
        const date = utc(startDate).add(dayNumber, "days");
        const formattedDate = formatISODate(date);

        return (
          <DayItem
            key={`day_${formattedDate}`}
            date={formattedDate}
            startDate={startDate}
            dayWidth={dayWidth}
            daysHeight={daysHeight}
          />
        );
      }),
    [daysCount, startDate, dayWidth]
  );

  return daysHeight ? (
    <div className={css.root} style={{ height: daysHeight }}>
      {dayItems}
    </div>
  ) : null;
};
